










import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "AgroInterativeLoading",
})
export default class AgroInterativeLoading extends Vue {}
